import React from 'react';

import { MenuItem } from '@mui/material';
// import { withStyles } from '@mui/styles';
// import PropTypes from 'prop-types';

// import style from './selectStyle';
import injectStores from '../RootStore/injectStores';

/**
 * @class Select
 * @description dropdown menu used to select various items
 */
interface SelectItemProps {
  currentValue?: string | number;
  disabled?: boolean;
  "data-value"?: string;
  value?: string | number;
  [key: string]: unknown;
}

const SelectItem: React.FC<SelectItemProps> = (props) => {
  const { currentValue, disabled, "data-value": dataValue, ...rest } = props;
  return (
    <MenuItem
      // classes={{
      //   root: classes.selectMenuItem,
      //   selected: classes.selectMenuItemSelected,
      // }}
      disabled={disabled}
      {...rest}
      data-value={dataValue}
    >
      {dataValue || rest.value}
    </MenuItem>
  );
};

// SelectItem.muiName = 'MenuItem';

// SelectItem.defaultProps = {
//   disabled: false,
// };

// SelectItem.propTypes = {
//   classes: PropTypes.object,
//   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   disabled: PropTypes.bool,
// };

/** SelectItem
 * @param {String|Number} value Value of SelectItem
 * @param {Boolean} [disabled] - Optional
 * @example
 * // In a map
 *  <SelectItem value={selectValue} key={selectValue} />
 * // Disabled
 *  <SelectItem value="Selection" disabled={true} />
 */
export default injectStores(SelectItem);
